import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import moduleStyles from './customer-welcome-message.module.scss';

const styles = classNames.bind(moduleStyles);

const CustomerWelcomeMessage = ({ isCustomerAuthenticated }) => {
  const [message, setMessage] = useState('Welcome Back!');
  /*
    Set the message visibility to hidden on the server.
    This prevents the quick flash from a message without a username
    to a message with username on the client on the client.
  */
  const [hidden, setHidden] = useState(true);

  const messageStyles = styles('message-text', { hidden });

  useEffect(() => {
    // Reset the message on customer authentication change.
    setMessage('Welcome Back!');
    if (isCustomerAuthenticated) {
      const customer = window.THDCustomer?.default || {};
      const { username } = customer;

      if (username && username.toLowerCase() !== 'self') {
        setMessage(`Welcome Back, ${username.toLowerCase()}!`);
      }
    }

    /*
      Even if we don't get a username from the cookie, we still want to display
      the initial message, which is why this is not inside the above `if`.
    */
    setHidden(false);
  }, [isCustomerAuthenticated]);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('customer-welcome-message.ready');
  }, []);

  return (
    <div className={styles('customer-welcome-message')}>
      <h2
        data-automation-id="customer-welcome-message"
        className={messageStyles}
      >
        {message}
      </h2>
    </div>
  );
};

CustomerWelcomeMessage.displayName = 'CustomerWelcomeMessage';

CustomerWelcomeMessage.propTypes = {
  isCustomerAuthenticated: PropTypes.bool
};

CustomerWelcomeMessage.defaultProps = {
  isCustomerAuthenticated: false
};

export { CustomerWelcomeMessage };
